import Vue from 'vue'
import Router from 'vue-router'
import { local, KEY_USER_TOKEN, session, KEY_MEDIATEK_2025GIVINGTREE_TOKEN } from '@/tools/storage'

const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onResolve, onReject) {
  if (onResolve || onReject) { return originalPush.call(this, location, onResolve, onReject) }
  const result = originalPush.call(this, location)
  return result && result.catch ? result.catch((err) => err) : result
}

const originalReplace = Router.prototype.replace
Router.prototype.replace = function replace (location, onResolve, onReject) {
  if (onResolve || onReject) { return originalReplace.call(this, location, onResolve, onReject) }
  const result = originalReplace.call(this, location)
  return result && result.catch ? result.catch((err) => err) : result
}

Vue.use(Router)

// 路由文件必须放在container目录下
const _import = require('./_import_' + process.env.NODE_ENV)

const router = new Router({
  mode: 'history',
  routes: [
    ...(process.env.NODE_ENV === 'development' ? [{
      path: '/dev/united-group',
      component: () => import('@/container/carbonlabelling/unitedGroupPreview.vue')
    }] : []),
    /* 底部tab路由 */
    {
      path: '/',
      component: _import('Root'),
      meta: {
        keepAlive: true
      },
      children: [{
        path: 'gifts',
        name: 'Gifts',
        component: _import('gift/Gifts'),
        meta: {
          keepAlive: true
        }
      },
      {
        path: 'needs',
        name: 'Needs',
        component: _import('need/Needs'),
        meta: {
          keepAlive: true
        }
      },
      {
        path: 'message',
        name: 'message',
        component: _import('message/Index'),
        meta: {
          auth: true,
          keepAlive: true
        }
      },
      {
        path: '',
        name: 'home',
        component: _import('Home'),
        meta: {
          keepAlive: true
        }
      }, {
        path: 'userinfo',
        name: 'UserInfo',
        component: _import('UserInfo'),
        meta: {
          auth: true,
          keepAlive: true
        }
      }]
    },
    /* 底部tab路由 */
    /* 讀故事 */
    {
      path: '/story',
      name: 'Story',
      meta: {
        keepAlive: true
      },
      component: _import('story/index')
    }, {
      path: '/story/:id',
      name: 'StoryDeatil',
      meta: {
        title: '故事詳情'
      },
      component: _import('story/Detail')
    },
    /* 讀故事 */
    /* 排行榜 */
    {
      path: '/bonusRanking',
      name: 'BonusRanking',
      component: _import('BonusRanking')
    },
    /* 排行榜 */
    /* 禮物 */
    {
      path: '/gift/:id(\\d+)',
      name: 'GiftDetail',
      component: _import('gift/GiftDetail')
    }, {
      path: '/gift/new',
      name: 'NewGift',
      component: _import('gift/NewGift'),
      meta: {
        auth: true
      }
    }, {
      path: '/gift/edit/:id',
      name: 'EditGift',
      component: _import('gift/EditGift'),
      meta: {
        auth: true
      }
    }, {
      path: '/gift/send',
      name: 'SendGift',
      component: _import('gift/SendGift')
    }, {
      path: '/request/:id',
      name: 'Request',
      component: _import('gift/Request'),
      meta: {
        auth: true
      }
    }, {
      path: '/requestSuc',
      name: 'RequestSuc',
      component: _import('gift/RequestSuc')
    }, {
      path: '/gift/confirmShip',
      name: 'GiftConfirmShip',
      component: _import('gift/ConfirmShip')
    },
    /* 禮物 */
    /* 需求 */
    {
      path: '/need/new',
      name: 'NewNeed',
      meta: {
        auth: true
      },
      component: _import('need/NewNeed')
    }, {
      path: '/need/edit/:id',
      name: 'EditNeed',
      component: _import('need/EditNeed'),
      meta: {
        auth: true
      }
    }, {
      path: '/need/:id(\\d+)',
      name: 'NeedDetail',
      component: _import('need/NeedDetail')
    }, {
      path: '/need/take',
      name: 'ReceiveDonate',
      component: _import('need/ReceiveDonate')
    }, {
      path: '/need/confirmShip',
      name: 'NeedConfirmShip',
      component: _import('need/ConfirmShip')
    }, {
      path: '/donate/:id',
      name: 'Donate',
      component: _import('need/Donate'),
      meta: {
        auth: true
      }
    }, {
      path: '/need-purchase/:id',
      component: _import('need/Purchase'),
      meta: {
        auth: true
      }
    }, {
      path: '/needDonate/:id',
      name: 'needDonate',
      component: _import('need/NeedDonateDetail')
    }, {
      path: '/donateSuc',
      name: 'DonateSuc',
      component: _import('need/DonateSuc')
    },
    /* 需求 */
    /* 用戶主頁 */
    {
      path: '/user/:hash',
      // name: 'user',
      component: _import('user/index'),
      children: [{
        path: '',
        name: 'NotMe',
        meta: {
          title: {
            self: '我的用戶資料',
            other: '贈友檔案'
          }
        },
        component: _import('user/User')
      },
      {
        path: 'gifts',
        name: 'UserGifts',
        meta: {
          title: {
            self: '我的送禮物',
            other: '送禮物'
          },
          withoutHeader: true
          // keepAlive: true
        },
        component: _import('user/Gifts')
      }, {
        path: 'brandGifts',
        name: 'UserBrandGifts',
        meta: {
          title: {
            self: '我的品牌好物',
            other: '品牌好物'
          },
          withoutHeader: true
        },
        component: _import('user/BrandGifts/index')
      }, {
        // 品牌好物黑名單（企業端私有，入口在品牌好物管理右上角）
        path: 'brandGifts/blacklist',
        name: 'UserBrandGiftBlacklist',
        meta: {
          withoutHeader: true
        },
        component: _import('user/BrandGifts/blacklist')
      }, {
        path: 'needs',
        name: 'UserNeeds',
        meta: {
          title: {
            self: '我的需求',
            other: '需求'
          },
          withoutHeader: true
        },
        component: _import('user/Needs')
      }, {
        path: 'brandSignature',
        name: 'BrandSignature',
        meta: {
          // title: {
          //   self: '品牌簽名檔',
          //   other: '品牌簽名檔'
          // }
          withoutHeader: true
        },
        component: _import('user/BrandSignature')
      }, {
        path: 'thanksWord',
        name: 'UserThanks',
        meta: {
          title: {
            self: '我的感謝',
            other: '感謝'
          }
        },
        component: _import('user/thanksWord')
      },
      {
        path: 'deals',
        name: 'Deals',
        meta: {
          title: {
            self: '我索取過的物品',
            other: '索取過的物品'
          }
        },
        component: _import('user/ReqGifts')
      },
      {
        path: 'wishes',
        name: 'userWish',
        meta: {
          title: {
            self: '心願認養',
            other: '心願認養'
          }
        },
        component: _import('wishes/UserWish')
      },
      {
        path: 'traces',
        name: 'UserTraces',
        meta: {
          title: {
            self: '我的追蹤'
          }
        },
        component: _import('user/Traces')
      },
      {
        path: 'subscribe',
        name: 'Subscribe',
        meta: {
          title: {
            self: '我的關鍵字訂閱'
          },
          auth: true
        },
        component: _import('user/Subscribe')
      },
      {
        path: 'privateNote',
        name: 'PrivateNote',
        meta: {
          title: {
            self: '我的好壞名單'
          },
          auth: true
        },
        component: _import('user/PrivateNote')
      },
      {
        path: 'love',
        name: 'Love',
        meta: {
          title: {
            self: '分享減碳專區'
          },
          auth: true
        },
        component: _import('user/Love')
      },
      {
        path: 'shop',
        name: 'Shop',
        meta: {
          title: {
            self: '我索取的GC代贈'
          },
          auth: true
        },
        component: _import('user/Shop')
      },
      {
        path: 'provisions',
        name: 'Provisions',
        meta: {
          title: {
            self: '分享減碳行動專區',
            other: '分享減碳行動專區'
          }
        },
        component: _import('user/Provisions')
      },
      {
        path: 'fans',
        name: 'Fans',
        meta: {
          title: {
            self: ''
          }
        },
        component: _import('user/Fans')
      },
      {
        path: 'traces',
        name: 'Traces',
        meta: {
          title: {
            self: '追蹤詳情'
          }
        },
        component: _import('user/Traces')
      },
      {
        path: 'setting',
        name: 'Setting',
        meta: {
          title: {
            self: '設置'
          },
          auth: true
        },
        component: _import('user/Setting')
      },
      {
        path: 'editBaseInfo',
        name: 'EditBaseInfo',
        meta: {
          title: {
            self: '基本資料'
          },
          auth: true
        },
        component: _import('user/EditBaseInfo')
      },
      {
        path: 'change',
        name: 'Change',
        meta: {
          title: {
            self: '變更會員身份'
          },
          auth: true
        },
        component: _import('user/ChangeIdentity')
      },
      {
        path: 'editRemit',
        name: 'EditRemit',
        meta: {
          title: {
            self: '收款及其他資訊'
          },
          auth: true
        },
        component: _import('user/EditRemit')
      },
      {
        path: 'addresses',
        name: 'Addresses',
        meta: {
          title: {
            self: '聯絡地址'
          },
          auth: true
        },
        component: _import('user/Addresses')
      },
      {
        path: 'moments',
        name: 'UserMoments',
        component: _import('user/moments'),
        meta: {
          title: {
            self: '我的說說',
            other: '說說'
          }
        }
      },
      {
        path: 'dashboard_wallet',
        redirect: to => {
          const { query } = to
          return {
            path: '/wallet/records',
            query: { type: query.type }
          }
        }
      },
      {
        path: 'wallet',
        name: 'UserWallet',
        component: _import('user/Wallet'),
        meta: {
          withoutHeader: true
        }
      },
      {
        path: 'sponsor',
        name: 'UserSponsor',
        component: _import('user/Sponsor'),
        meta: {
          title: {
            self: '我的贊助記錄'
          }
        }
      },
      {
        path: 'dashboard_sponsor',
        redirect: to => {
          const { params } = to
          return {
            path: `/user/${params.hash}/sponsor`
          }
        }
      },
      {
        path: 'dashboard_shop',
        redirect: to => {
          const { params } = to
          return {
            path: `/user/${params.hash}/shop`
          }
        }
      },
      {
        path: 'dashboard_coupons',
        redirect: to => {
          return {
            path: `/wallet/coupons`
          }
        }
      },
      {
        path: 'commonweals',
        name: 'Commonweals',
        component: _import('user/Commonweals'),
        meta: {
          title: {
            self: '受益公益團體/學校',
            other: '受益公益團體/學校'
          }
        }
      }
      ]
    },
    {
      path: '/resetpw',
      meta: {
        title: '忘記密碼'
      },
      component: _import('user/ResetPw')
    }, {
      path: '/verifycellphone',
      meta: {
        title: '手機驗證',
        auth: true
      },
      component: _import('user/VerifyCellPhone')
    }, {
      path: '/confirm/:hash/code/:code',
      redirect: to => {
        const { params } = to
        return {
          path: '/verifyemail',
          query: {
            hash: params.hash,
            code: params.code
          }
        }
      }
    }, {
      path: '/reset/:hash/code/:code',
      redirect: to => {
        const { params } = to
        return {
          path: '/resetpw',
          query: {
            hash: params.hash,
            code: params.code
          }
        }
      }
    }, {
      path: '/verifyemail',
      meta: {
        title: '信箱驗證'
      },
      component: _import('user/VerifyEmail')
    }, {
      path: '/verifyname',
      meta: {
        title: '實名驗證',
        auth: true
      },
      component: _import('user/VerifyId')
    }, {
      path: '/verifylovebox',
      meta: {
        title: 'GC代贈驗證',
        auth: true
      },
      component: _import('user/VerifyLoveBox')
    }, {
      path: '/chpw',
      name: 'Chpw',
      meta: {
        title: '修改密碼',
        auth: true
      },
      component: _import('user/ChangePw')
    }, {
      path: '/newconnect',
      name: 'NewConnect',
      meta: {
        title: '交接預告',
        auth: true
      },
      component: _import('user/NewConnect')
    },
    /* 用戶主頁 */
    /* 感謝 */
    {
      path: '/thanks',
      name: 'Thanks',
      component: _import('ThanksWall')
    },
    /* 登錄 */
    {
      path: '/login',
      name: 'Login',
      component: _import('enter/Login')
    },
    {
      path: '/mailLogin',
      name: 'MailLogin',
      component: _import('enter/MailLogin')
    },
    /* 註冊 */
    {
      path: '/register',
      name: 'Register',
      component: _import('enter/Register')
    }, {
      path: '/register/phone',
      name: 'RegisterPhone',
      component: _import('enter/RegisterPhoneDetail'),
      meta: {
        auth: true
      }
    }, {
      path: '/registerSuccess',
      name: 'RegisterSuccess',
      component: _import('enter/RegisterSuccess')
    }, {
      path: '/changeLogin',
      name: 'ChangeLogin',
      component: _import('enter/ChangeLogin')
    }, {
      path: '/changeType/:hash/code/:code',
      redirect: to => {
        const { params } = to
        return {
          path: '/changeLogin',
          query: {
            hash: params.hash,
            code: params.code
          }
        }
      }
    },
    /* 互動卡 */
    {
      path: '/chatroom/:id',
      name: 'chatroom',
      component: _import('message/Chatroom'),
      meta: {
        auth: true
      }
    },
    {
      path: '/talk/:id',
      name: 'talk',
      component: _import('message/Talk'),
      meta: {
        auth: true
      }
    },
    {
      path: '/service-protocol',
      name: 'ServiceProtocol',
      component: _import('info/ServiceProtocol')
    },
    {
      path: '/agreement',
      redirect: to => {
        return {
          path: `/service-protocol`
        }
      }
    },
    {
      path: '/aboutGCNew',
      name: 'About543New',
      meta: {
        title: '關於我們'
      },
      component: _import('info/About543New')
    }, {
      path: '/aboutGC',
      name: 'About543',
      meta: {
        title: '關於我們'
      },
      component: _import('info/About543')
    }, {
      path: '/privacy',
      name: 'Privacy',
      component: _import('info/Privacy')
    }, {
      path: '/search',
      name: 'Search',
      component: _import('Search')
    }, {
      path: '/taipei/about',
      name: 'TaiPeiAbout',
      component: _import('info/AboutTaiPei')
    }, {
      path: '/donatefood',
      name: 'DonateFood',
      component: _import('info/DonateFood')
    },
    /* 会员变更页面 */
    {
      path: '/firmIdentity/:hash',
      name: 'FirmIdentity',
      meta: {
        title: '企業行號',
        auth: true
      },
      component: _import('user/FirmIdentity')
    }, {
      path: '/officeIdentity/:hash',
      name: 'OfficeIdentity',
      meta: {
        title: '政府機關',
        auth: true
      },
      component: _import('user/OfficeIdentity')
    }, {
      path: '/schoolIdentity/:hash',
      name: 'SchoolIdentity',
      meta: {
        title: '學校單位',
        auth: true
      },
      component: _import('user/SchoolIdentity')
    }, {
      path: '/loveMemIdentity/:hash',
      name: 'LoveMemIdentity',
      meta: {
        title: '關懷會員',
        auth: true
      },
      component: _import('user/LoveMemIdentity')
    }, {
      path: '/benefitIdentity/:hash',
      name: 'BenefitIdentity',
      meta: {
        title: '公益團體',
        auth: true
      },
      component: _import('user/BenefitIdentity')
    },
    /* 確認收到提示頁面 */
    {
      path: '/confirmSent',
      name: 'ConfirmSent',
      component: _import('message/ItemSent')
    },
    /* 感謝頁面 */
    {
      path: '/thanksItem/:id',
      name: 'ThanksItem',
      component: _import('message/ThanksItem')
    },
    /* GC代贈 */
    {
      path: '/love/subscribe',
      name: 'LoveSubscribe',
      component: _import('lovebox/Subscribe'),
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/course/subscribe',
      name: 'LoveCourseSubscribe',
      component: _import('lovebox/CourseSubscribe')
    },
    {
      path: '/lovebox',
      name: 'Lovebox',
      component: _import('lovebox/Index'),
      meta: {
        keepAlive: true
      }
    }, {
      path: '/lovebox/new',
      name: 'NewLovebox',
      component: _import('lovebox/NewLovebox'),
      meta: {
        auth: true
      }
    }, {
      path: '/lovebox/:id',
      name: 'LoveboxDetail',
      component: _import('lovebox/Detail')
    }, {
      path: '/shopCart',
      name: 'ShopCart',
      component: _import('lovebox/ShopCart')
    }, {
      path: '/bookSuc',
      name: 'BookSuc',
      component: _import('lovebox/BookSuc')
    }, {
      path: '/aboutLovebox',
      name: 'AboutLovebox',
      component: _import('lovebox/About')
    }, {
      path: '/contactLovebox',
      name: 'ContactLovebox',
      component: _import('lovebox/Contact')
    }, {
      path: '/loveboxThanks/:id',
      name: 'LoveboxThanks',
      component: _import('lovebox/Thanks')
    }, {
      path: '/loveboxBatchThanks',
      name: 'LoveboxBatchThanks',
      component: _import('lovebox/BatchThanks')
    }, {
      path: '/activitynotice',
      name: 'ActivityNotice',
      component: _import('ActivityNotice')
    },
    /* 索取赠送交易管理页面 */
    {
      path: '/dealsReq',
      name: 'ReqAll',
      component: _import('deals/request/Index'),
      meta: {
        auth: true,
        keepAlive: true
      }
    },
    {
      path: '/dealsReq/search',
      name: 'ReqSearch',
      component: _import('deals/request/search'),
      meta: {
        auth: true
      }
    },
    {
      path: '/dealsReq/:status',
      name: 'ReqStatus',
      component: _import('deals/request/status'),
      meta: {
        auth: true
        // keepAlive: true
      }
    },
    {
      path: '/dealsDonate',
      name: 'DonateAll',
      component: _import('deals/donate/Index'),
      meta: {
        auth: true,
        keepAlive: true
      }
    },
    {
      path: '/dealsDonate/:status',
      name: 'donateStatus',
      component: _import('deals/donate/status'),
      meta: {
        auth: true
      }
    },
    /* 索取赠送交易管理页面 */
    /* 台北社會局 */
    {
      path: '/city/taipei',
      name: 'CityTaipei',
      component: _import('taipei/Index')
    },
    {
      path: '/city/taipei/about',
      name: 'CityTaipeiAbout',
      component: _import('taipei/About')
    },
    {
      path: '/city/taipei/commonweal',
      name: 'CityTaipeiCommonweal',
      component: _import('taipei/Commonweal')
    },
    {
      path: '/city/taipei/gifts',
      redirect: to => {
        return {
          path: '/city/taipei',
          query: {
            tab: 0
          }
        }
      }
    },
    {
      path: '/city/taipei/needs',
      redirect: to => {
        return {
          path: '/city/taipei',
          query: {
            tab: 1
          }
        }
      }
    },
    {
      path: '/city/taipei/donatefood',
      redirect: to => {
        return {
          path: '/city/taipei',
          query: {
            tab: 2
          }
        }
      }
    },
    {
      path: '/city/taipei/need/:id',
      redirect: to => {
        const { params } = to
        return {
          path: `/need/${params.id}`
        }
      }
    },
    {
      path: '/city/taipei/gift/:id',
      redirect: to => {
        const { params } = to
        return {
          path: `/gift/${params.id}`
        }
      }
    },
    /* 常見問題 */
    {
      path: '/guide',
      name: 'Faq',
      component: _import('answer/faq')
    },
    {
      path: '/guide/member',
      name: 'BecomeMember',
      component: _import('answer/becomeMember')
    },
    {
      path: '/guide/give',
      name: 'UploadGift',
      component: _import('answer/uploadGift')
    },
    {
      path: '/guide/donate',
      name: 'FaqSendGift',
      component: _import('answer/sendGift')
    },
    {
      path: '/guide/request-success',
      name: 'SuccessRecevieGift',
      component: _import('answer/successRecevieGift')
    },
    {
      path: '/guide/request',
      name: 'DemandGift',
      component: _import('answer/demandGift')
    },
    {
      path: '/guide/want',
      name: 'RequestRequirement',
      component: _import('answer/requestRequirement')
    },
    {
      path: '/guide/want-donate',
      name: 'RequirementSend',
      component: _import('answer/requirementSend')
    },
    {
      path: '/guide/link',
      name: 'MemberExchange',
      component: _import('answer/memberExchange')
    },
    {
      path: '/guide/manager',
      name: 'ManagerGiftRequirement',
      component: _import('answer/managerGiftRequirement')
    },
    {
      path: '/guide/fami',
      name: 'howToSentFami',
      component: _import('answer/howToSentFami')
    },
    /* 用戶回覆 */
    {
      path: '/feedback',
      name: 'Feedback',
      component: _import('user/Feedback')
    },
    {
      path: '/survey/social-worker',
      name: 'SurveySocialWorker',
      component: _import('survey/SocialWorker'),
      meta: {
        title: 'GC贈物網影響力評估：社工'
      }
    },
    {
      path: '/festival/votes',
      name: 'FestivalVotes',
      component: _import('festival/votes')
    },
    {
      path: '/festival/:id(\\d+)?',
      name: 'FestivalDetail',
      component: _import('festival/Detail')
    },
    {
      path: '/festival/release',
      name: 'FestivalRelease',
      component: _import('anniversary/release')
    },
    // {
    //   path: '/anniversary/:id(\\d+)?',
    //   name: 'Anniversary',
    //   component: _import('anniversary/index')
    // }, {
    //   path: '/anniversary/release',
    //   name: 'AnniversaryRelease',
    //   component: _import('anniversary/release'),
    //   meta: {
    //     auth: true,
    //     keepAlive: true
    //   }
    // },
    {
      path: '/cabinetGift',
      name: 'CabinetGift',
      component: _import('cabinetGift/Index'),
      meta: {
        keepAlive: true
      }
    }, {
      path: '/wishes',
      name: 'Wishes',
      component: _import('wishes/Wishes'),
      meta: {
        keepAlive: true
      }
    }, {
      path: '/viswishes',
      name: 'VISWishes',
      component: _import('wishes/VisWishes'),
      meta: {
        keepAlive: true
      }
    }, {
      path: '/viswishes/intro',
      name: 'VISWishesIntro',
      component: _import('wishes/VisWishesIntro'),
      meta: {
        keepAlive: true
      }
    }, {
      path: '/wishes/intro',
      name: 'KuentaiWishIntro',
      component: _import('wishes/KuentaiWishIntro')
    }, {
      path: '/wishes/reading-intro',
      name: 'KuentaiReadingIntro',
      component: _import('wishes/KuentaiReadingIntro')
    }, {
      path: '/wish/:id(\\d+)?',
      name: 'Wish',
      component: _import('wishes/Details')
    }, {
      path: '/wish/confirm/:id(\\d+)?',
      name: 'WishConfirm',
      component: _import('wishes/Confirm')
    }, {
      path: '/wish/finish/:id(\\d+)?',
      name: 'WishFinish',
      component: _import('wishes/Finish')
    }, {
      path: '/wish/after/:id(\\d+)',
      name: 'wishAfter',
      component: _import('wishes/After')
    }, {
      path: '/merge/request',
      name: 'mergeRequest',
      meta: {
        keepAlive: true
      },
      component: _import('merge/Request')
    }, {
      path: '/unauthorized',
      name: 'Unauthorized',
      component: _import('Unauthorized'),
      meta: {
        title: '401 未授權'
      }
    },
    {
      path: '/notfound',
      name: 'NotFound',
      component: _import('NotFound'),
      meta: {
        title: '404 無資源'
      }
    },
    {
      path: '/moments',
      name: 'Moments',
      component: _import('moments/index'),
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/moment/:id(\\d+)',
      name: 'MomentDetail',
      component: _import('moments/detail')
    },
    {
      path: '/moment/release',
      name: 'MomentRelease',
      component: _import('moments/release'),
      meta: {
        auth: true,
        keepAlive: true
      }
    },
    {
      path: '/moment/reminder',
      name: 'MomentReminder',
      component: _import('moments/reminder')
    },
    // 服務總覽
    {
      path: '/serviceMenu',
      name: 'ServiceMenu',
      component: _import('serviceMenu/index')
    },
    {
      path: '/carbonAccount/guide',
      name: 'CarbonAccountGuide',
      component: _import('carbonAccount/guide')
    },
    { // GC減碳帳戶使用者條款
      path: '/carbonAccount/service-protocol',
      name: 'CarbonAccountServiceProtocol',
      component: _import('carbonAccount/serviceProtocol/index')
    },
    { // GC減碳帳戶試用界面
      path: '/carbonAccount/trail',
      name: 'CarbonAccountTrailHome',
      component: _import('carbonAccount/trail/index')
    },
    { // GC減碳帳戶——付款界面
      path: '/carbonAccount/purchase',
      name: 'CarbonAccountPurchase',
      component: _import('carbonAccount/purchase/index')
    },
    { // GC減碳帳戶管理 —— GC減碳帳戶才有的
      path: '/carbonAccount/manage',
      name: 'CarbonAccountManage',
      component: _import('carbonAccount/manage/index')
    },
    { // GC減碳帳戶管理-下載數據報表
      path: '/carbonAccount/manage/downloadReport',
      name: 'CarbonAccountManageDownloadReport',
      component: _import('carbonAccount/manage/downloadReport/index')
    },
    { // GC減碳帳戶管理-申請減碳證書
      path: '/carbonAccount/manage/applyCert',
      name: 'CarbonAccountManageApplyCert',
      component: _import('carbonAccount/manage/applyCert/index')
    },
    { // GC減碳帳戶管理-會員狀態
      path: '/carbonAccount/manage/status',
      name: 'CarbonAccountManageStatus',
      component: _import('carbonAccount/manage/status/index')
    },
    { // GC減碳帳戶管理-服務訂購記錄
      path: '/carbonAccount/manage/records',
      name: 'CarbonAccountManageRecords',
      component: _import('carbonAccount/manage/records/index')
    },

    {
      path: '/deal/cancel',
      name: 'CancelDeal',
      component: _import('deals/cancel')
    },
    {
      path: '/deal/pay',
      name: 'PayDeal',
      component: _import('deals/pay')
    },
    {
      path: '/deal/editAddress',
      name: 'EditDealAddress',
      component: _import('deals/editAddress')
    },
    {
      path: '/invite',
      name: 'UserInvite',
      component: _import('user/Invite'),
      meta: {
        title: {
          self: '邀請新會員',
          other: '邀請新會員'
        },
        auth: true
      }
    },
    {
      path: '/invite/rules',
      name: 'InviteRules',
      component: _import('invite/rules')
    },
    {
      path: '/unsubscribe',
      name: 'UnsubscribeEmail',
      component: _import('user/UnsubscribeEmail')
    },
    {
      path: '/address/edit',
      name: 'AddAddress',
      component: _import('user/AddAddress')
    },
    {
      path: '/sponsorship',
      name: 'HeartWall',
      component: _import('heartwall/HeartWall')
    },
    {
      path: '/heartwallwords',
      name: 'HeartWallWords',
      component: _import('heartwall/HeartWallWords')
    },
    {
      path: '/heartwallsponsor/:id(\\d+)',
      name: 'HeartWallSponsor',
      component: _import('heartwall/HeartWallSponsor')
    },
    {
      path: '/heartwallsponsor/:id(\\d+)/expired',
      name: 'HeartWallExpired',
      component: _import('heartwall/SponsorExpired')
    },
    {
      path: '/wallet/charge',
      name: 'WalletCharge',
      component: _import('wallet/Charge')
    },
    {
      path: '/wallet/chargeResult',
      name: 'WalletChargeResult',
      component: _import('wallet/ChargeResult')
    },
    {
      path: '/wallet/records',
      name: 'WalletRecords',
      component: _import('wallet/Records')
    },
    {
      path: '/wallet/passcode',
      name: 'WalletPasscode',
      component: _import('wallet/Passcode')
    },
    {
      path: '/wallet/faq',
      name: 'WalletFaq',
      component: _import('wallet/Faq')
    },
    {
      path: '/wallet/invoice',
      name: 'WalletInvoice',
      component: _import('wallet/Invoice')
    },
    {
      path: '/wallet/greenpoint',
      name: 'WalletGreenpoint',
      component: _import('wallet/Greenpoint')
    },
    {
      path: '/ibox/query',
      name: 'iBoxQuery',
      component: _import('ibox/query')
    },
    {
      path: '/direct_purchase',
      name: 'DirectPurchase',
      component: _import('need/DirectPurchase')
    },
    {
      path: '/partner/momo',
      name: 'MomoPartner',
      component: _import('partners/momo')
    },
    {
      path: '/express',
      name: 'Express',
      component: _import('express/index'),
      meta: {
        auth: true
      }
    },
    {
      path: '/express/:uuid/rcv_address',
      name: 'ExpressAddress',
      component: _import('express/RcvAddress')
    },
    {
      path: '/express/orders',
      name: 'ExpressOrders',
      component: _import('express/Orders')
    },
    {
      path: '/express/order/:id(\\d+)',
      name: 'ExpressOrder',
      component: _import('express/OrderDetail')
    },
    {
      path: '/fontSize',
      name: 'FontSize',
      component: _import('FontSize')
    },
    {
      path: '/dashboard/profile',
      redirect: to => {
        const { query } = to
        return {
          path: `/user/${query.user_id}/editBaseInfo`
        }
      }
    },
    {
      path: '/flashGifts',
      name: 'FlashGifts',
      component: _import('gift/FlashGifts')
    },
    {
      path: '/dormGifts',
      name: 'DormGifts',
      component: _import('gift/DormGifts')
    },
    {
      path: '/deal/:id',
      name: 'DealDetail',
      component: _import('deals/detail'),
      meta: {
        auth: true
      }
    },
    {
      path: '/readings',
      redirect: to => {
        const { query } = to
        return {
          path: '/wishes',
          query: {
            school: query.school,
            year: query.year,
            type: 1
          }
        }
      }
    },
    {
      path: '/reading/:id',
      redirect: to => {
        const { params } = to
        return {
          path: `/wish/${params.id}`
        }
      }
    },
    {
      path: '/wallet/coupons',
      name: 'WalletCoupons',
      component: _import('wallet/Coupons')
    },
    {
      path: '/company/:hash',
      component: _import('user/index'),
      children: [{
        path: '',
        name: 'Company',
        meta: {
          title: {
            self: '我的資料',
            other: '企業主頁'
          }
        },
        component: _import('user/User')
      }]
    },
    {
      path: '/bindCarbonLabelling',
      name: 'BindCarbonLabelling',
      component: _import('user/BindCarbonLabelling'),
      meta: {
        auth: false
      }
    },
    {
      path: '/welfare/bindEnterprises',
      name: 'BindEnterprise',
      component: _import('welfare/bind'),
      meta: {
        auth: false
      }
    },
    {
      path: '/welfare',
      component: _import('welfare/root'),
      children: [
        {
          path: '',
          name: 'WelfareIntro',
          component: _import('welfare/intro')
        },
        {
          path: 'sendFlower',
          name: 'SendFlower',
          component: _import('welfare/send')
        },
        {
          path: 'getFlower',
          name: 'GetFlower',
          component: _import('welfare/get')
        },
        {
          path: 'award',
          name: 'Award',
          component: _import('welfare/award')
        }
      ]
    },
    {
      path: '/earthday2026',
      component: _import('earthday/root'),
      children: [
        {
          path: '',
          name: 'EarthdayIntroduction',
          component: _import('earthday/introduction')
        },
        {
          path: 'declaration',
          name: 'EarthdayDeclaration',
          component: _import('earthday/declaration')
        },
        {
          path: 'achievement',
          name: 'EarthdayAchievement',
          component: _import('earthday/achievement')
        }
      ]
    },
    {
      path: '/deactivate',
      component: _import('user/deactivate'),
      name: 'Deactivate'
    },
    {
      path: '/socialworkday',
      component: _import('socialworkday/root'),
      children: [
        {
          path: '',
          name: 'SocialWorkDayIntro',
          component: _import('socialworkday/introduction')
        },
        {
          path: 'encourage',
          name: 'SocialWorkDayEncourage',
          component: _import('socialworkday/encourage'),
          meta: {
            auth: true
          }
        },
        {
          path: 'messages',
          name: 'SocialWorkDayMessages',
          component: _import('socialworkday/messages')
        },
        {
          path: 'awards',
          name: 'SocialWorkDayAwards',
          component: _import('socialworkday/awards')
        },
        {
          path: 'awards/dingwang',
          name: 'SocialWorkDayAward1',
          component: _import('socialworkday/dingwang')
        },
        {
          path: 'awards/aimasi',
          name: 'SocialWorkDayAward2',
          component: _import('socialworkday/aimasi')
        },
        {
          path: 'awards/beiduona',
          name: 'SocialWorkDayAward3',
          component: _import('socialworkday/beiduona')
        }
      ]
    },
    {
      path: '/wpgwishes',
      name: 'WPGWishes',
      component: _import('wishes/WPGWishes'),
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/makalot-wishes',
      name: 'MAKALOTWishesIntro',
      component: _import('wishes/MakalotWishesIntro')
    },
    {
      path: '/makalot-wishes/list',
      name: 'MAKALOTWishes',
      component: _import('wishes/MakalotWishes'),
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/carbonlabelling/:id(\\d+)',
      name: 'CarbonLabellingGroup',
      component: _import('carbonlabelling/groupResultPage')
    },
    {
      path: '/unitedgroup/:id(\\d+)',
      name: 'UnitedGroup',
      component: _import('carbonlabelling/unitedGroup')
    },
    {
      path: '/carbonlabelling/users',
      name: 'CarbonLabellingUsers',
      component: _import('carbonlabelling/users'),
      meta: {
        auth: true
      }
    },
    {
      path: '/companyPage/:hash',
      name: 'CompanyPage',
      component: _import('CompanyPage')
    },
    {
      path: '/thankTemplates',
      name: 'ThankTemplates',
      component: _import('ThankTemplates')
    },
    {
      path: '/thankTemplate/edit',
      name: 'AddThankTemplate',
      component: _import('AddThankTemplate')
    },
    {
      path: '/inviteCarbonLabelling',
      name: 'InviteCarbonLabelling',
      component: _import('user/InviteCarbonLabelling'),
      meta: {
        auth: false
      }
    },
    {
      path: '/carbonlabelling/groups',
      name: 'CarbonLabellingGroups',
      component: _import('carbonlabelling/groups'),
      meta: {
        auth: true
      }
    },
    /* GC Group 線上課程（用戶端）；通知深連結約定為 /group-course/{group_id}/course/{course_id} */
    {
      path: '/group-course/:groupId(\\d+)',
      name: 'GroupCourseList',
      component: _import('groupCourse/CourseList'),
      meta: {
        auth: true,
        title: '團隊課程'
      }
    },
    {
      path: '/group-course/:groupId(\\d+)/course/:courseId(\\d+)',
      name: 'GroupCourseDetail',
      component: _import('groupCourse/CourseDetail'),
      meta: {
        auth: true,
        title: '課程詳情'
      }
    },
    {
      path: '/carbonlabelling/:id(\\d+)/setting',
      name: 'CarbonLabellingGroupSetting',
      component: _import('carbonlabelling/setting'),
      meta: {
        auth: true
      }
    },
    {
      path: '/carbonlabelling/:id(\\d+)/manage',
      name: 'CarbonLabellingManageHome',
      component: _import('carbonlabelling/manage'),
      meta: {
        auth: true
      }
    },
    {
      path: '/carbonlabelling/:id(\\d+)/member_changes',
      name: 'CarbonLabellingMemberChanges',
      component: _import('carbonlabelling/memberChanges'),
      meta: {
        auth: true
      }
    },
    {
      path: '/carbonlabelling/:id(\\d+)/announcements',
      name: 'CarbonLabellingAnnouncements',
      component: _import('carbonlabelling/announcements'),
      meta: {
        auth: true
      }
    },
    {
      path: '/carbonlabelling/:id(\\d+)/quit',
      name: 'CarbonLabellingGroupQuit',
      component: _import('carbonlabelling/quit'),
      meta: {
        auth: true
      }
    },
    {
      path: '/carbonlabelling/:id(\\d+)/userInfo',
      name: 'CarbonLabellingGroupUserInfo',
      component: _import('carbonlabelling/userInfo'),
      meta: {
        auth: true
      }
    },
    {
      path: '/carbonlabelling/:id(\\d+)/influence',
      name: 'CarbonLabellingGroupInfluence',
      component: _import('carbonlabelling/influence'),
      meta: {
        auth: true
      }
    },
    {
      path: '/mediatek-2026givingtree',
      name: 'MediatekWishes',
      component: _import('mediatek/Wishes'),
      meta: {
        auth: true
      }
    },
    {
      path: '/mediatek-2026givingtree/login',
      name: 'MediatekLogin',
      component: _import('mediatek/Login')
    },
    {
      path: '/mediatek-2026givingtree/wish/:id(\\d+)?',
      name: 'MediatekWish',
      component: _import('mediatek/Details'),
      meta: {
        auth: true
      }
    },
    {
      path: '/mediatek-2026givingtree/wish/confirm/:id(\\d+)?',
      name: 'MediatekWishConfirm',
      component: _import('mediatek/Confirm'),
      meta: {
        auth: true
      }
    },
    {
      path: '/mediatek-2026givingtree/wish/finish/:id(\\d+)?',
      name: 'MediatekWishFinish',
      component: _import('mediatek/Finish'),
      meta: {
        auth: true
      }
    },
    {
      path: '/mediatek-2026givingtree/wish/after/:id(\\d+)',
      name: 'MediatekWishAfter',
      component: _import('mediatek/After'),
      meta: {
        auth: true
      }
    },
    {
      path: '/greenpoint',
      name: 'GreenPointIntro',
      component: _import('greenpoint/Introduction')
    },
    {
      path: '/greenpoint/gcmember',
      name: 'GCMember',
      component: _import('greenpoint/GCMember')
    },
    {
      path: '/greenpoint/gpmember',
      name: 'GPMember',
      component: _import('greenpoint/GPMember')
    },
    {
      path: '/needSections',
      name: 'NeedSections',
      component: _import('need/NeedSections')
    },
    {
      path: '/needSection/:id(\\d+)?',
      name: 'NeedSectionPool',
      component: _import('need/NeedSectionPool')
    },
    {
      path: '/app',
      name: 'AppIntroduction',
      component: _import('app/Introduction')
    },
    {
      path: '/brandGifts',
      name: 'BrandGifts',
      component: _import('gift/BrandGifts')
    },
    {
      path: '*',
      redirect: '/'
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (to.matched.some(t => t.meta.keepAlive)) {
      if (savedPosition === null) {
        to.meta.saved_position = null
      } else {
        savedPosition = to.meta.saved_position
      }
      const back = savedPosition || { x: 0, y: 0 }
      return back
    }
  }
})

router.beforeEach((to, from, next) => {
  if (from.meta.keepAlive) {
    from.meta.saved_position = {
      x: window.pageXOffset,
      y: window.pageYOffset
    }
  }

  if (to.path.startsWith('/mediatek-2026givingtree')) {
    let token = session.get(KEY_MEDIATEK_2025GIVINGTREE_TOKEN)
    if (to.matched.some(record => record.meta.auth)) {
      if (token) {
        next()
      } else {
        next({
          path: '/mediatek-2026givingtree/login',
          query: { redirect: to.path }
        })
      }
    } else {
      next()
    }
  } else {
    let token = local.get(KEY_USER_TOKEN)
    if (to.matched.some(record => record.meta.auth)) {
      if (token) {
        next()
      } else {
        if (from.path === '/login') {
          next({
            path: '/'
          })
        } else {
          next({
            path: '/login',
            query: { redirect: to.fullPath }
          })
        }
      }
    } else {
      next()
    }
  }
})

export default router
